import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnInit, Renderer2, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { DynamicPopupService, SideBarService } from 'projects/shared/src/public-api';
import { Observable, Subscription } from 'rxjs';
import { AppState, selecCompanyInCommonState, selectUserInCommonState } from '../../../app-state.index';
import { PermissionMenuItem } from '../menu/permission-menu-item';
import { TopbarService } from '../topbar/topbar.service';

@Component({
    selector: 'app-default-layout',
    templateUrl: './default-layout.component.html',
    styleUrls: ['./default-layout.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class DefaultLayoutComponent implements OnInit {

    topbarMenuActive: boolean;
    menuActive: boolean;
    staticMenuDesktopInactive: boolean;
    mobileMenuActive: boolean;
    menuClick: boolean;
    mobileTopbarActive: boolean;
    topbarRightClick: boolean;
    topbarItemClick: boolean;
    activeTopbarItem: string;
    documentClickListener: () => void;
    rightMenuActive: boolean;
    menuHoverActive = false;
    searchClick = false;
    search = false;
    subscriptions: Subscription = new Subscription();
    userInfo$: Observable<any>;
    company$: Observable<any>;
    visibleSidebar = false;
    contentSideBar: TemplateRef<any>;
    contentCanDeactive: () => Promise<any>;
    isLoading$: any;
    sidebarStyleClass: string;
    activeMenuItem: PermissionMenuItem;
    @Input() appConditionalStyle: string;

    _subscriptions: Array<Subscription> = new Array<Subscription>();
    @ViewChild("popup") popup: any;

    constructor(
        private sideBarServise: SideBarService,
        private store: Store<AppState>,
        public renderer: Renderer2,
        private cdr: ChangeDetectorRef,
        private topbarService: TopbarService,
        private dynamicPopupService: DynamicPopupService,
        private router: Router,
        private el: ElementRef
    ) {
        
    }

    //  private menuService: MenuService
    isHomeComponent(): boolean {
        return this.router.url.includes("home");
    }

    ngOnInit() {
        this.subscribeToOpenDynamicPopup();
        this.menuActive = this.isMobile();
        this.subscriptions.add(this.sideBarServise.contentSideBar.subscribe((content: TemplateRef<any>) => {
            if (this.sideBarServise.styleClass) {
                this.sidebarStyleClass = this.sideBarServise.styleClass;
                this.sideBarServise.styleClass = null;
            }
            else
                this.sidebarStyleClass = "p-sidebar-lg";

            this.contentSideBar = content;
            this.visibleSidebar = (content) ? true : false;

        }));
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.menuActive = false;
                this.mobileMenuActive = false;
                this.cdr.detectChanges();
            }
        });
        this.subscriptions.add(this.sideBarServise.contentDeActivate.subscribe((contentDeActivate: () => Promise<any>) => {
            this.contentCanDeactive = contentDeActivate;
        }));
        this.userInfo$ = this.store.select(selectUserInCommonState);
        this.company$ = this.store.select(selecCompanyInCommonState);
    }

    activeItem(event) {
        this.activeMenuItem = event;
        this.cdr.detectChanges();
    }

    ngAfterViewInit() {
        // hides the horizontal submenus or top menu if outside is clicked
        this.documentClickListener = this.renderer.listen('body', 'click', () => {
            if (!this.topbarItemClick) {
                this.activeTopbarItem = null;
                this.topbarMenuActive = false;
            }

            // if (!this.menuClick) {
            //     this.menuService.reset();
            // }

            if (!this.menuClick) {
                if (this.mobileMenuActive) {
                    this.mobileMenuActive = false;
                }
                this.menuHoverActive = false;
                this.unblockBodyScroll();
            }

            if (!this.searchClick) {
                this.search = false;
            }
            this.searchClick = false;
            this.topbarItemClick = false;
            this.topbarRightClick = false;
            this.menuClick = false;
        });
    }

     onMenuButtonClick(event) {
         this.menuActive = !this.menuActive;
         if(this.isDesktop()){
             this.openCloseMenu(event);
         }
         else{
             this.onButtonClick(event);
         }
     }

    onSideMenuClick(event) {
        this.menuActive = true;
        this.onButtonClick(event);
    }

    onButtonClick(event) {
        this.topbarMenuActive = false;
        this.topbarRightClick = true;
        this.menuClick = true;

        if (this.isDesktop()) {
            this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
        } else {
            this.mobileMenuActive = !this.mobileMenuActive;
            if (this.mobileMenuActive) {
                this.blockBodyScroll();
            } else {
                this.unblockBodyScroll();
            }
        }

        //event.preventDefault();
    }

    onTopbarMobileButtonClick(event) {
        this.mobileTopbarActive = !this.mobileTopbarActive;
        event.preventDefault();
    }

    onRightMenuButtonClick(event) {
        this.rightMenuActive = !this.rightMenuActive;
        event.preventDefault();
    }

    onMenuClick($event) {
        this.menuClick = true;
        this.openCloseMenu(this.menuActive)
    }

    onSearchKeydown(event) {
        if (event.keyCode === 27) {
            this.search = false;
        }
    }

    onTopbarItemClick(event, item) {
        this.topbarItemClick = true;

        if (this.activeTopbarItem === item) {
            this.activeTopbarItem = null;
        }
        else {
            this.activeTopbarItem = item;
        }

        if (item === 'search') {
            this.search = !this.search;
            this.searchClick = !this.searchClick;
        }

        event.preventDefault();
    }

    onTopbarSubItemClick(event) {
        event.preventDefault();
    }

    isDesktop() {
        return window.innerWidth > 991;
    }

    isMobile() {
        return window.innerWidth <= 991;
    }

    blockBodyScroll(): void {
        if (document.body.classList) {
            document.body.classList.add('blocked-scroll');
        } else {
            document.body.className += ' blocked-scroll';
        }
    }

    unblockBodyScroll(): void {
        if (document.body.classList) {
            document.body.classList.remove('blocked-scroll');
        } else {
            document.body.className = document.body.className.replace(new RegExp('(^|\\b)' +
                'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    }

    removeSideBar() {
        if (!this.contentCanDeactive) {
            return;
        }
        this.contentCanDeactive().then((res: boolean) => {
            if (!res) {
                this.visibleSidebar = true;
                return;
            }
            this.sideBarServise.setContentSideBar(null);
            this.sideBarServise.setContentDeActivate(null);
        });
    }

    ngOnDestroy() {
        if (this.documentClickListener) {
            this.documentClickListener();
        }
        if (this.subscriptions) {
            this.subscriptions.unsubscribe();
        }
    }
    openGmailChat() {
        const email = 'kesherhk@gmail.com'; // כתובת האימייל שאליה רוצים לשלוח הודעה
        const chatUrl = `https://mail.google.com/mail/u/0/?view=cm&fs=1&tf=1&to=${email}`;
        window.open(chatUrl, '_blank');
    }
    openCloseMenu(event) {
            // Add a small delay or check to prevent immediate reopening
            if (this.menuActive) {
                // Only close if not hovering over side menu
                if (!this.isHoveringSideMenu()) {
                    this.topbarService.openCloseMenu.emit();
                    this.onMenuButtonClick(event);
                }
            } else {
                return 0;
            }
        }
        isHoveringSideMenu(): boolean {
            const sideMenuElement = document.querySelector('side-menu');
            return sideMenuElement && sideMenuElement.matches(':hover');
        }
    private subscribeToOpenDynamicPopup() {
        this._subscriptions.push(this.dynamicPopupService.getOpenDynamicPopupClicked()
            .subscribe(data => {
                this.popup.open(data);
            }))
    }
     //#region  Functions- when exiting the main menu
isHoveringMainMenu = false;
menuCloseTimeout: any;
onMainMenuLeave() {
        this.isHoveringMainMenu = false;
        this.menuCloseTimeout = setTimeout(() => {
          // בודקים אם העכבר לא עבר לתפריט המשני
          if (!document.querySelector('.menu-wrapper')?.matches(':hover')) {
            this.menuActive = false;
            this.mobileMenuActive = false;
            this.cdr.detectChanges();
          }
        }, 100); // זמן קצר למנוע סגירה מיידית
      }

    onMenuMouseEnter(event: MouseEvent) {
        clearTimeout(this.menuCloseTimeout);
    }

    closeMenu() {
        this.menuActive = false;
        this.mobileMenuActive = false;
        this.cdr.detectChanges();
    }
  //#endregion

}
